import { backendRequest } from "@/lib/backend/api";

export type ReportTarget = "post" | "user";
export type ReportReason = "spam" | "harassment" | "fraud" | "inappropriate" | "other";

export function reportContent(targetType: ReportTarget, targetId: string, reason: ReportReason) {
  return backendRequest<{ id: string; status: string; createdAtUtc: string }>(
    "/api/v1/safety/reports",
    {
      method: "POST",
      body: JSON.stringify({ targetType, targetId, reason }),
    }
  );
}

export function getUserBlockStatus(userId: string) {
  return backendRequest<{ isBlocked: boolean }>(
    `/api/v1/safety/blocks/${encodeURIComponent(userId)}`
  );
}

export function blockUser(userId: string) {
  return backendRequest<{ isBlocked: boolean }>(
    `/api/v1/safety/blocks/${encodeURIComponent(userId)}`,
    { method: "POST" }
  );
}

export function unblockUser(userId: string) {
  return backendRequest<{ isBlocked: boolean }>(
    `/api/v1/safety/blocks/${encodeURIComponent(userId)}`,
    { method: "DELETE" }
  );
}
